import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

interface ProgressiveImageProps {
  src: string;
  thumbnailSrc: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  objectFit?: 'cover' | 'contain';
}

interface StyledImageProps {
  isLoaded: boolean;
  objectFit: 'cover' | 'contain';
}

const ImageContainer = styled.div`
  overflow: hidden;
  line-height: 0;
  width: 100%;
  height: 100%;
`;

const StyledImage = styled.img<StyledImageProps>`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.objectFit};
  opacity: ${(props) => (props.isLoaded ? 1 : 0.8)};
  filter: ${(props) => (props.isLoaded ? 'none' : 'blur(10px)')};
  transform: ${(props) => (props.isLoaded ? 'scale(1)' : 'scale(1.1)')};
`;

export const ProgressiveImage = ({
  src,
  thumbnailSrc,
  alt,
  className,
  style,
  objectFit = 'cover'
}: ProgressiveImageProps) => {
  const [currentSrc, setCurrentSrc] = useState(thumbnailSrc);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setCurrentSrc(src);
      setIsLoaded(true);
    };
    img.onerror = (e) => {
      console.error('Full image failed to load:', src, e);
    };
  }, [src]);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error('Displayed image failed to load:', currentSrc, e);
  };

  return (
    <ImageContainer className={className} style={style}>
      <StyledImage
        src={currentSrc}
        alt={alt}
        isLoaded={isLoaded}
        onError={handleError}
        objectFit={objectFit}
      />
    </ImageContainer>
  );
}; 